﻿<script>
	export let id;
	export let value;
	export let label = false;
	export let optionList;
	export let textProperty = "label";
	export let valueProperty = "value";
	export let showHead = true;
	export let disabled = null;
	export let readonly = null;
	export let required = null;

	let className = $$props.class ? " " + $$props.class : "";
	let style = $$props.style ? $$props.style : null;
</script>

{#if label}<label for={id} class:isrequired={required}>{@html label}</label>{/if}
<select {id} bind:value {disabled} {readonly} {required} class="form-control{className}" {style} on:change>
	{#if showHead == true}
		<option value="">Select...</option>
	{/if}
	{#each optionList as item}
		<option value={item[valueProperty]} selected={item[valueProperty] == value}>{item[textProperty]}</option>
	{/each}
</select>
